import styled, { keyframes } from 'styled-components';
import { Alert } from 'UI';

export const AlertContainer = styled.div`
  position: fixed;
  width: 100vw;
  display: flex;
  justify-content: center;
  z-index: 100;
`;

const alertAnimationKeyframe = keyframes`
  0% {
    transform: translateY(-38px);
  }
  100% {
    transform: translateY(18px);
  }
`;

export const AnimatedAlert = styled(Alert)`
  animation: ${alertAnimationKeyframe} 0.3s ease;
  transform: translateY(18px);
`;

export const PageWrapper = styled.div`
  display: flex;
  padding-left: 256px;
`;

export const PageContent = styled.div`
  display: flex;
  padding: 2rem;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1 0 0;
  max-width: 100%;
`;
